import * as onlineApi from '../../../api/fuel_request/online'
import IntlMessages from '../../../util/IntlMessages'
import * as router from '../../../constants/router'
import * as constants from '../../../constants'
import * as common from '../common'
import * as field from '../field'

export const operatorFuelRequestHistoryAction = () => async (dispatch, getState) => {
    let currentState = getState()
    let vOperatorMobileNumber = currentState.config.mobile
    let result = await onlineApi.operatorFuelRequestHistory({ vOperatorMobileNumber, vType: 'new' })
    if (result.status) dispatch(field.setFields([
        { data: result.data[0].list, field: 'list' },
        { data: result.data[0].details, field: 'details' }
    ]))
}

export const viewFuelRequestOnlineByOperatorAction = (vRequestCode) => (dispatch, getState) => {
    let currentState = getState()
    let vOperatorMobileNumber = currentState.config.mobile
    onlineApi.viewFuelRequestOnlineByOperator({ vRequestCode, vOperatorMobileNumber })
}

export const operatorRequestInprocessListAction = (vType = constants.FUEL_REQUEST_INPROCESS_TYPE_LIST) => async (dispatch, getState) => {
    let currentState = getState()
    let vOperatorMobileNumber = currentState.config.mobile
    let result = await onlineApi.operatorRequestInprocessList({ vOperatorMobileNumber, vType })
    if (result.status) dispatch(field.setFields([{ data: result.data, field: 'list' }]))
}

export const requestDetailsAction = (vRequestCode) => async (dispatch, getState) => {
    let currentState = getState()
    if (vRequestCode !== '') {
        if (!currentState.common.loadingPage)
            dispatch(common.loadingPageAction(true))
        let result = await onlineApi.requestDetails({
            vRequestCode,
            vRequestDetailsType: constants.REQUEST_DETAILS_TYPE
        })
        if (result.status) {
            dispatch(field.setFields([
                { data: result.data[0], field: 'requestOnline' },
                { data: result.data[0].operatorLocation, field: 'operatorLocation' }]))
            dispatch(common.loadingPageAction(false))
        }
        else dispatch(common.redirectAction(router.HOME))
    } else dispatch(common.redirectAction(router.HOME))
}

export const operatorRefuelingAction = (vRequestCode) => async (dispatch, getState) => {
    dispatch(common.loadingBtnAction(true))
    let currentState = getState()
    let vOperatorMobileNumber = currentState.config.mobile
    let result = await onlineApi.operatorRefueling({ vRequestCode, vOperatorMobileNumber })
    if (result.status) {
        await dispatch(requestDetailsAction(vRequestCode))
        dispatch(common.snackbarAction(true, result.message))
    }
    dispatch(common.loadingBtnAction(false))
}

export const operatorCompleteRequestAction = ({ vRequestCode, iPaymentType, iUserCarAccuracy }) => async (dispatch, getState) => {
    dispatch(common.loadingBtnAction(true))
    let currentState = getState()
    let vOperatorMobileNumber = currentState.config.mobile
    let result = await onlineApi.operatorCompleteRequest({
        vRequestCode,
        vOperatorMobileNumber,
        iPaymentType,
        iUserCarAccuracy
    })
    if (result.status) {
        dispatch(common.redirectAction(router.HOME))
        dispatch(field.setFields([{ field: 'empty_requestOnline' }]))
        dispatch(common.snackbarAction(true, result.message))
    }
    dispatch(common.loadingBtnAction(false))
}

export const volumeReceivedConfirmationAction = (vRequestCode, litrage, litrageDecimal) => async (dispatch) => {
    let iVolume = getVolume(litrage, litrageDecimal)
    dispatch(common.loadingBtnAction(true))
    if (iVolume) {
        let result = await onlineApi.volumeReceivedConfirmation({ vRequestCode, iVolume })
        if (result.status) {
            await dispatch(requestDetailsAction(vRequestCode))
            dispatch(common.snackbarAction(true, result.message))
        }
    } else dispatch(common.snackbarAction(true, <IntlMessages id="enteredFontIsIncorrect" />))
    dispatch(common.loadingBtnAction(false))
}

export const statusFuelRequestAction = (vRequestCode) => async (dispatch, getState) => {
    let currentState = getState()
    let result = await onlineApi.statusFuelRequest({
        vRequestCode,
        iPersonType: constants.PERSON_TYPE,
        vOperatorMobileNumber: currentState.config.mobile,
    })
    if (result.status) {
        let data = result.data[0]
        if (checkEndRequest(data.iStatus)) {
            dispatch(common.redirectAction(router.HOME))
            dispatch(field.setFields([{ field: 'empty_requestOnline' }]))
            dispatch(common.snackbarAction(true,
                data.iStatus === constants.FUEL_REQUEST_END ?
                    <IntlMessages id="yourOnlineRefuelingIsComplete" /> :
                    <IntlMessages id="yourOnlineRefuelingHasBeenCanceled" />
            ))
        } else {
            if (data.statusFuelRequest) dispatch(requestDetailsAction(vRequestCode))
            dispatch(field.setFields([{ field: 'operatorLocation', data: data.operatorLocation }]))
        }
    } else {
        dispatch(common.redirectAction(router.HOME))
    }
}

const checkEndRequest = (status) =>
    status === constants.FUEL_REQUEST_END || status === constants.FUEL_REQUEST_CANCEL_BY_ADMIN || status === constants.FUEL_REQUEST_CANCEL ? true : false


const getVolume = (litrage, litrageDecimal) => {
    litrageDecimal = litrageDecimal === "" ? 0 : litrageDecimal
    if (litrage !== '' && litrage > 0) return parseInt(litrage) + '.' + litrageDecimal
    return false
}